import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";
import useAdminData from "../hooks/useAdminData";
import { AdminTabs } from "../components/admin/AdminUI";
import { OverviewPanel, ListsPanel, TablesPanel, PaymentsPanel, UsersPanel, ScoutingPanel } from "../components/admin/Panels";
import EventsPanel from "../components/admin/EventsPanel";
import FoldersPanel from "../components/admin/FoldersPanel";
import ContentPanel from "../components/admin/content/ContentPanel";

function AdminHeader({ name }) {
  return (
    <div className="flex items-center justify-between mb-8 pb-6 border-b border-neutral-800">
      <div>
        <div className="label-mono text-alert mb-1">// CONTROL_CENTER</div>
        <h1 className="font-display text-3xl lg:text-5xl">ADMIN<span className="text-alert">.</span>DASH</h1>
      </div>
      <div className="font-mono text-xs text-neutral-500"><span className="text-neon">●</span> ONLINE · {name.toUpperCase()}</div>
    </div>
  );
}

export default function Admin() {
  const { user, loading } = useAuth();
  const [tab, setTab] = useState("overview");
  const isAdmin = user?.role === "admin";
  const d = useAdminData(isAdmin);

  if (loading) return <div className="p-16 text-center text-neutral-500 font-mono">LOADING...</div>;
  if (!isAdmin) return <Navigate to="/login" replace/>;

  return (
    <div className="max-w-[1600px] mx-auto px-4 lg:px-8 py-10">
      <AdminHeader name={user.name}/>
      <AdminTabs tab={tab} setTab={setTab}/>
      {tab==="overview" && <OverviewPanel user={user} stats={d.stats}/>}
      {tab==="contents" && <ContentPanel onChange={d.load}/>}
      {tab==="events" && <EventsPanel events={d.events} onChange={d.load}/>}
      {tab==="lists" && <ListsPanel lists={d.lists} clicks={d.clicks} events={d.events} users={d.users}/>}
      {tab==="folders" && <FoldersPanel folders={d.folders} events={d.events} onChange={d.load}/>}
      {tab==="tables" && <TablesPanel tables={d.tables} events={d.events} onChange={d.load}/>}
      {tab==="payments" && <PaymentsPanel payments={d.payments} users={d.users} tables={d.tables}/>}
      {tab==="users" && <UsersPanel users={d.users} onChange={d.load}/>}
      {tab==="scouting" && <ScoutingPanel scouting={d.scouting}/>}
    </div>
  );
}
